import template from './template.html';
import blockBase from "../../mixins/blockBase";
import api from '../../api/send-quote';
import validators from "../../helpers/validators";
require('jcf/dist/js/jcf');
require('jcf/dist/js/jcf.select');
require('jcf/dist/js/jcf.file');

export default {
    name: 'calculator',
    template: template,
    mixins: [
        blockBase,
    ],
    data() {
        return {
            step: 1,
            active: 0,
            design: 0,
            frontend: 0,
            backend: 0,
            engine: 'Select from list',
            cost: 0,
            days: 0,
            quoteEmail: '',
            quoteEmailValidation: '',
        };
    },
    computed: {
        fields() {
            return this.$store.getters.getAcfOptionField('calculator')
        },
        steps() {
            return this.fields.steps;
        },
        isValidEmail() {
            return validators.required.fn(this.quoteEmail) && validators.email.fn(this.quoteEmail)
        },
    },
    methods: {
        toggle(index) {
            this.initSelect()
            this.$set(this, 'active', index);

            if (index === 3) {
                this.calcCost()
                this.calcDays()
            }
        },
        calcCost() {
            this.cost = 0
            if (this.design) {
                this.cost = 20 * 8 * this.design
            }
            if (this.frontend) {
                this.cost += 25 * 12 + (this.frontend - 1) * 8 * 22
            }
            if (this.backend) {
                this.cost += 25 * 5 * (this.engine === 'custom' ? this.backend * 2 : this.backend)
            }
            this.cost = this.cost || 0
        },
        calcDays() {
            this.days = 0
            if (this.design) {
                this.days = this.design * 16
            }
            if (this.frontend) {
                this.days += (this.frontend - 1) * 9 + 13
            }
            if (this.backend) {
                this.days += (this.engine === 'custom' ? this.backend * 2 : this.backend) * 6
            }
            this.days = Math.ceil(this.days / 6) || 0
        },
        zeroingModel(model) {
            switch (model) {
                case 'design':
                    this.design = 0;
                    return;
                case 'frontend':
                    this.frontend = 0;
                    return;
                case 'backend':
                    this.backend = 0;
                    return;
                default:
                    return;
            }
        },
        inCalc(index) {
            const step = this.steps.filter(s => s.step === index)
            _.forEach(step, (obj) => {
                obj.inCalc = !obj.inCalc
            })
        },
        deepStepToggle(index) {
            const step = this.steps.filter(s => s.step === index)
            _.forEach(step, (obj) => {
                obj.deepStep = !obj.deepStep
            })
        },
        initSelect() {
            jcf.setOptions('Select', {
                wrapNative: false,
                wrapNativeOnMobile: false
            });
            jcf.setOptions('File', {
                buttonText: 'Upload file...',
                placeholderText: ''
            });
            jcf.replaceAll();
        },
        modal(ref) {
            const vm = this
            vm.initCF7()
            $.fancybox.open({
                src  : vm.$refs[ref],
                type : 'inline',
                touch: false
            })
        },
        initCF7() {
            $(this.$el).find('.wpcf7-form').each(function (index, elem) {
                wpcf7.init(elem);

                if (wpcf7.cached) {
                    wpcf7.refill(elem);
                }
            });
        },
        async sendQuote() {

            if (! validators.required.fn(this.quoteEmail)) {
                this.$refs.quoteEmailField.classList.add('not-valid')
                this.quoteEmailValidation = validators.required.message
                return false
            }

            if (! validators.email.fn(this.quoteEmail)) {
                this.$refs.quoteEmailField.classList.add('not-valid')
                this.quoteEmailValidation = validators.email.message
                return false
            }

            this.$refs.quoteEmailField.classList.remove('not-valid')
            this.quoteEmailValidation = ''

            const params = {
                design: this.design > 0 ? 'Yes' : 'No',
                designPages: this.design > 0 ? this.design : '-',
                frontend: this.frontend > 0 ? 'Yes' : 'No',
                frontendPages: this.frontend > 0 ? this.frontend : '-',
                backend: this.backend > 0 ? 'Yes' : 'No',
                backendPages: this.backend > 0 ? this.backend : '-',
                engine: this.engine === 'custom' ? 'Custom' : 'Wordpress',
                cost: this.cost,
                days: this.days,
                email: this.quoteEmail,
            }
            await api.request({
                    params: params
                })
                .then(response => {
                    this.quoteEmail = ''
                    this.$refs.responseText.style.display = 'block'
                    if (response.data.sent) {
                        this.$refs.responseText.classList.remove('mail-validation-errors')
                        this.$refs.responseText.classList.add('mail-sent-ok')
                        this.$refs.responseText.innerHTML = 'The quote has been sent to your mailbox.'
                        setTimeout(() => {
                            $.fancybox.close()
                            this.$refs.responseText.style.display = 'none'
                            this.$refs.responseText.classList.remove('mail-sent-ok')
                        }, 5000)
                    } else {
                        this.$refs.responseText.classList.remove('mail-sent-ok', 'mail-validation-errors')
                        this.$refs.responseText.classList.add('mail-validation-errors')
                        this.$refs.responseText.innerHTML = 'Mail sending failed. Please try later.'
                    }
                })
                .catch(error => console.log(error));

        }
    },
    mounted() {
        setTimeout(() => {
            _.forEach(this.steps, (obj, key) => {
                this.$set(obj, 'step', key)
                this.$set(obj, 'inCalc', false)
                this.$set(obj, 'deepStep', false)
            })
        }, 1000)

        const vm = this
        $(document).ready(function() {
            vm.initCF7();
        });
    }
};